<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Rachunki'" [name]="'Dodaj'"></app-breadcrumb>
<div class="certificate-add" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!billFormVaild || processingRequest || modifyInvoice "
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Dodaj</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div [fxFlex]="'50'" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane rachunku</h3>
        </div>
        <div fxLayout="row">
          <app-month-picker
            fxFlex="100"
            label="Miesiąc rozliczeniowy" [required]="false"
            [control]="billingMonthControl" [disabledDatePicker]="true" [readonly]="true"
          ></app-month-picker>
        </div>

        <app-bills-file-drag-and-drop
          [multiple]="true"
          [fileControl]="fileControl"
          [fileResults]="fileResults"
          (invoiceControl)="selectedInvoice($event)"
          [deleteInvoiceObject]="deleteInvoiceObject"
          [invoiceFileResult]="invoiceFileResult"
          [invoiceObjectReturn]="invoiceObjectReturn"
          acceptMime="application/pdf">

        </app-bills-file-drag-and-drop>

      </mat-card>
    </div>
    <div [fxFlex]="'50'" fxFlex.lt-md="100" fxLayoutGap="15px" [formGroup]="invoiceForm">
      <mat-card>
        <div fxLayout="row">
          <h3>Weryfikacja rachunku</h3>
          <span fxFlex></span>
        </div>
        <mat-progress-spinner *ngIf="processingRequestInvoice" style="margin:0 auto;" mode="indeterminate"></mat-progress-spinner>
        <div fxLayout="column" *ngIf="invoiceObject && !processingRequestInvoice">
          <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" fxLayoutAlign="start end">
            <app-detail fxFlex header="Nazwa pliku" [value]="invoiceObject?.fileName"></app-detail>
            <button *ngIf="!modifyInvoice" (click)="shownInvoice(invoiceObject)" mat-stroked-button color="primary">
              <mat-icon>search</mat-icon> <span> Podgląd skanu</span>
            </button>
          </div>
          <div fxLayout="row  mt-20">
            <h3>Dane faktury</h3>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <app-detail  *ngIf="!modifyInvoice" fxFlex="50" header="Miesiąc rozliczeniowy" [value]="invoiceObject?.billingMonth"></app-detail>
            <app-month-picker *ngIf="modifyInvoice" fxFlex="50" label="Miesiąc rozliczeniowy" [required]="false"
                              [control]="billingMonthControl" [disabledDatePicker]="true" [readonly]="true"
            ></app-month-picker>
            <app-detail *ngIf="!modifyInvoice" fxFlex="50" header="Numer" [value]="invoiceObject?.number"></app-detail>
            <mat-form-field *ngIf="modifyInvoice" fxFlex="50">
              <mat-label>Numer</mat-label>
              <input matInput placeholder="Numer" [formControl]="numberControl" [required]="true">
              <mat-error *ngIf="numberControl.hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="numberControl.hasError('backendError')">{{numberControl.getError('backendError')}}</mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <app-detail *ngIf="!modifyInvoice"  fxFlex="50" header="Kwota faktury">
              {{(invoiceObject?.gross === null ? 0 : invoiceObject?.gross) | number:'1.2-2'}} zł
            </app-detail>
            <mat-form-field *ngIf="modifyInvoice" fxFlex="50">
              <mat-label>Kwota faktury"</mat-label>
              <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="grossControl">
              <mat-error *ngIf="grossControl.hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="grossControl.hasError('backendError')">{{grossControl.getError('backendError')}}</mat-error>
            </mat-form-field>
            <app-detail *ngIf="!modifyInvoice" fxFlex="50" header="Kwota do wypłaty">
              {{(invoiceObject?.payoutNet === null ? 0 : invoiceObject?.payoutNet) | number:'1.2-2'}} zł
            </app-detail>
            <mat-form-field *ngIf="modifyInvoice" fxFlex="50">
              <mat-label>Kwota do wypłaty"</mat-label>
              <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="netControl">
              <mat-error *ngIf="netControl.hasError('required')">To pole jest wymagane</mat-error>
              <mat-error *ngIf="netControl.hasError('backendError')">{{netControl.getError('backendError')}}</mat-error>
            </mat-form-field>

          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="50">
              <app-detail *ngIf="!modifyInvoice" header="Data wystawienia" [value]="invoiceObject?.issueDate | date:'y-MM-dd'"></app-detail>
              <app-datepicker *ngIf="modifyInvoice" label="Data wystawienia" [required]="true" [control]="issueDateControl"  placeholder="2000-01-01 00:00"></app-datepicker>
            </div>

            <div fxFlex="50">
              <app-detail *ngIf="!modifyInvoice"  header="Data usługi" [value]="invoiceObject?.serviceDate | date:'y-MM-dd'"></app-detail>
              <app-datepicker *ngIf="modifyInvoice" label="Data usługi" [required]="true" [control]="serviceDateControl"  placeholder="2000-01-01 00:00"></app-datepicker>
            </div>
          </div>
          <div fxLayout="row mt-20">
            <h3>Relacje</h3>
          </div>

          <ng-container *ngIf="!modifyInvoice">
            <div fxLayout="row">
              <app-detail fxFlex="100" header="Umowa"
                          [value]="invoiceObject?.partner?.fullName + ', ' + invoiceObject?.contract?.type?.name + ' (nr: ' + invoiceObject?.contract?.number + '), '
                            + invoiceObject?.contract?.status.name">
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="invoiceObject?.partner">
              <app-detail fxFlex="50" header="Strona umowy" value="Partner"></app-detail>
              <app-detail fxFlex="50" header="Partner" [value]="invoiceObject?.partner?.shortName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="invoiceObject?.ofwca">
              <app-detail fxFlex="50" header="Strona umowy" value="OFWCA"></app-detail>
              <app-detail fxFlex="100" header="OFWCA" [value]="invoiceObject?.ofwca?.fullName"></app-detail>
            </div>

            <div fxLayout="row">
              <h3>Dane sprzedawcy</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="100" header="Nazwa firmy" [value]="invoiceObject?.sellerCompanyName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Ulica" [value]="invoiceObject?.sellerStreet"></app-detail>

              <div fxFlex="50" fxLayout="row" fxLayoutGap="15px">
                <app-detail fxFlex="50" header="Nr budynku" [value]="invoiceObject?.sellerHouseNumber"></app-detail>
                <app-detail fxFlex="50" header="Nr mieszkania" [value]="invoiceObject?.sellerApartmentNumber"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Poczta" [value]="invoiceObject?.sellerPostCity"></app-detail>
              <app-detail fxFlex="50" header="Kod pocztowy" [value]="invoiceObject?.sellerZipCode"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Miejscowość" [value]="invoiceObject?.sellerCity"></app-detail>
              <app-detail fxFlex="50" header="Numer rachunku bankowego" [value]="invoiceObject?.sellerAccountNumber"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Email" [value]="invoiceObject?.sellerEmail"></app-detail>
              <app-detail fxFlex="50" header="Numer telefonu" [value]="invoiceObject?.sellerPhone | phone"></app-detail>
            </div>
          </ng-container>
          <ng-container *ngIf="modifyInvoice">
            <div fxLayout="row">
              <app-dict-all-contracts
                fxFlex="100"
                label="Umowa do rozliczenia"
                [required]="true"
                [control]="contractControl"
                [filterPartnership]="true"
                [addInvoiceContract]="true"
                [showElements]="5"
                (selectedContract)="contractChanged($event); contractChangedSecond($event)"
              ></app-dict-all-contracts>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" class="mt-20">
              <mat-form-field fxFlex="100">
                <mat-label>Numer rachunku bankowego</mat-label>
                <input
                  prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
                  matInput placeholder="PL27 1140 2004 0000 3002 0135 5387" [formControl]="sellerAccountNumberControl" >
                <mat-error *ngIf="sellerAccountNumberControl.hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
              </mat-form-field>
            </div>
          </ng-container>
          <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" class="mt-20">
            <button *ngIf="!modifyInvoice" (click)="modify(invoiceObject)" mat-stroked-button color="primary">
              <mat-icon>create</mat-icon> <span> Edytuj</span></button>
            <button *ngIf="modifyInvoice" (click)="sendForm(invoiceObject.id, invoiceObjectIndex)"   mat-stroked-button color="primary">
              <mat-icon>save</mat-icon> <span> Zapisz</span></button>
            <span *ngIf="!modifyInvoice" fxFlex></span>
            <button *ngIf="!modifyInvoice"
                    (click)="delete(invoiceObject)" mat-stroked-button color="warn">
              <mat-icon>delete</mat-icon> <span> Usuń</span></button>

            <button *ngIf="modifyInvoice" (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

          </div>
        </div>

      </mat-card>
    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!billFormVaild || processingRequest || modifyInvoice"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Dodaj</span></button>
    <!--    <button (click)="reload()"  *ngIf="addFile" mat-stroked-button color="primary"><mat-icon>refresh</mat-icon> <span> Odśwież</span></button>-->
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
